import { Outlet, Route, Routes } from 'react-router-dom';

import { PageTitle } from '@/_metronic/layout/core';
import FactoryListPage from '@/modules/factory/components/FactoryListPage';

const FactoryPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  { isActive: false, isSeparator: false, path: '/factory/list', title: 'Nhà máy' },
                ]}
              >
                Danh sách nhà máy
              </PageTitle>
              <FactoryListPage />
            </>
          }
          path="list"
        />
      </Route>
    </Routes>
  );
};

export default FactoryPage;
